/** @jsx jsx */
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { cssMap, jsx } from '@atlaskit/css';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const CardTick = () => {
	const { formatMessage } = useIntl();

	return (
		<div css={styles.root}>
			<Tooltip content={formatMessage(messages.done)}>
				<CheckMarkIcon color={token('color.icon.success')} label="" size="small" />
			</Tooltip>
		</div>
	);
};

const styles = cssMap({
	root: {
		// These styles allow elements to receive pointer events even with the use of the
		// InteractionLayer component in the board card component. The InteractionLayer
		// component is used to create a clickable area for the card, but we want to
		// ensure that certain elements within the card can still receive pointer events.
		position: 'relative',
		pointerEvents: 'auto',
	},
});
